// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-menu ion-content {
  --background: var(--ion-item-background, var(--ion-background-color, #fff));
}

ion-menu.md ion-content {
  --padding-start: 8px;
  --padding-end: 8px;
  --padding-top: 20px;
  --padding-bottom: 20px;
}

ion-menu.md ion-list {
  padding: 20px 0;
}

ion-menu.md ion-note {
  margin-bottom: 30px;
}

ion-menu.md ion-list-header,
ion-menu.md ion-note {
  padding-left: 10px;
}

ion-menu.md ion-list#inbox-list {
  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);
}

ion-menu.md ion-list#inbox-list ion-list-header {
  font-size: 22px;
  font-weight: 600;
  min-height: 20px;
}

ion-menu.md ion-list#labels-list ion-list-header {
  font-size: 16px;
  margin-bottom: 18px;
  color: #757575;
  min-height: 26px;
}

ion-menu.md ion-item {
  --padding-start: 10px;
  --padding-end: 10px;
  border-radius: 4px;
}

ion-menu.md ion-item.selected {
  --background: rgba(var(--ion-color-default-rgb), 0.14);
}

ion-menu.md ion-item.selected ion-icon {
  color: var(--ion-color-default);
}

ion-menu.md ion-item ion-icon {
  color: #616e7e;
}

ion-menu.md ion-item ion-label {
  font-weight: 500;
}

ion-menu.ios ion-content {
  --padding-bottom: 20px;
}

ion-menu.ios ion-list {
  padding: 20px 0 0 0;
}

ion-menu.ios ion-note {
  line-height: 24px;
  margin-bottom: 20px;
}

ion-menu.ios ion-item {
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 50px;
}

ion-menu.ios ion-item.selected ion-icon {
  color: var(--ion-color-default);
}

ion-menu.ios ion-item ion-icon {
  font-size: 24px;
  color: #73849a;
}

ion-menu.ios ion-list#labels-list ion-list-header {
  margin-bottom: 8px;
}

ion-menu.ios ion-list-header,
ion-menu.ios ion-note {
  padding-left: 16px;
  padding-right: 16px;
}

ion-menu.ios ion-note {
  margin-bottom: 8px;
}

ion-menu {
  --width: 100%;
  --max-width: 100%;
  --min-width: 100%;
}

.accounts_section {
  border-right: 1px solid var(--ion-item-border-color);
  display: flex;
  flex-direction: column;
  align-items: center;
}
.accounts_section ion-avatar {
  width: 40px;
  height: 40px;
  background: var(--ion-color-danger);
  border-radius: 34.5px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 0;
  text-align: center;
  color: var(--ion-color-primary-contrast);
  border: 2px solid var(--ion-color-danger);
  display: flex;
  align-items: center;
  justify-content: center;
}
.accounts_section ion-avatar.add_btn {
  background: var(--ion-color-default);
  border: 2px solid var(--ion-color-primary);
}
.accounts_section ion-avatar.active {
  background: var(--ion-color-default);
  border: 2px solid var(--ion-color-success);
}

ion-note {
  display: inline-block;
  font-size: 16px;
  color: var(--ion-color-medium-shade);
}

ion-item.selected {
  --color: var(--ion-color-default);
}

ion-item.menu-profile-item {
  padding-bottom: 25px;
  margin-bottom: 0;
  border-bottom: 1px solid var(--ion-item-border-color);
  border-radius: 0 !important;
}
ion-item.menu-profile-item ion-avatar {
  width: 56px;
  height: 56px;
  text-align: center;
  font-size: 40px;
  background: #FBFBFB;
  line-height: 63px;
}
ion-item.menu-profile-item ion-avatar img {
  width: 56px;
  height: 56px;
}

.left-bottom-icons {
  padding-bottom: 30px;
}

.network {
  position: absolute;
  top: 95%;
  height: 5%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.online-bg-color {
  background: #319718;
}

.offline-bg-color {
  background: #cf0b0b;
}

.orderApp {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  box-shadow: none;
}
.orderApp div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.orderApp div ion-icon {
  margin-right: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,2EAAA;AACF;;AAEA;EACE,oBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;;EAEE,kBAAA;AACF;;AAEA;EACE,2DAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EAEA,gBAAA;AAAF;;AAGA;EACE,eAAA;EAEA,mBAAA;EAEA,cAAA;EAEA,gBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,sDAAA;AAHF;;AAMA;EACE,+BAAA;AAHF;;AAMA;EACE,cAAA;AAHF;;AAMA;EACE,gBAAA;AAHF;;AAMA;EACE,sBAAA;AAHF;;AAMA;EACE,mBAAA;AAHF;;AAMA;EACE,iBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,qBAAA;EACA,mBAAA;EACA,kBAAA;AAHF;;AAMA;EACE,+BAAA;AAHF;;AAMA;EACE,eAAA;EACA,cAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;;EAEE,kBAAA;EACA,mBAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,aAAA;EACA,iBAAA;EACA,iBAAA;AAHF;;AAMA;EACE,oDAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAHF;AAKE;EACE,WAAA;EACA,YAAA;EACA,mCAAA;EACA,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,wCAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAHJ;AAME;EACE,oCAAA;EACA,0CAAA;AAJJ;AAOE;EACE,oCAAA;EACA,0CAAA;AALJ;;AASA;EACE,qBAAA;EACA,eAAA;EAEA,oCAAA;AAPF;;AAUA;EACE,iCAAA;AAPF;;AAUA;EACE,oBAAA;EACA,gBAAA;EACA,qDAAA;EACA,2BAAA;AAPF;AASE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;AAPJ;AASI;EACE,WAAA;EACA,YAAA;AAPN;;AAYA;EACE,oBAAA;AATF;;AAYA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAYA;EACE,mBAAA;AATF;;AAgBA;EACE,eAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAbF;AAcE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAZJ;AAaI;EACE,iBAAA;AAXN","sourcesContent":["ion-menu ion-content {\n  --background: var(--ion-item-background, var(--ion-background-color, #fff));\n}\n\nion-menu.md ion-content {\n  --padding-start: 8px;\n  --padding-end: 8px;\n  --padding-top: 20px;\n  --padding-bottom: 20px;\n}\n\nion-menu.md ion-list {\n  padding: 20px 0;\n}\n\nion-menu.md ion-note {\n  margin-bottom: 30px;\n}\n\nion-menu.md ion-list-header,\nion-menu.md ion-note {\n  padding-left: 10px;\n}\n\nion-menu.md ion-list#inbox-list {\n  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);\n}\n\nion-menu.md ion-list#inbox-list ion-list-header {\n  font-size: 22px;\n  font-weight: 600;\n\n  min-height: 20px;\n}\n\nion-menu.md ion-list#labels-list ion-list-header {\n  font-size: 16px;\n\n  margin-bottom: 18px;\n\n  color: #757575;\n\n  min-height: 26px;\n}\n\nion-menu.md ion-item {\n  --padding-start: 10px;\n  --padding-end: 10px;\n  border-radius: 4px;\n}\n\nion-menu.md ion-item.selected {\n  --background: rgba(var(--ion-color-default-rgb), 0.14);\n}\n\nion-menu.md ion-item.selected ion-icon {\n  color: var(--ion-color-default);\n}\n\nion-menu.md ion-item ion-icon {\n  color: #616e7e;\n}\n\nion-menu.md ion-item ion-label {\n  font-weight: 500;\n}\n\nion-menu.ios ion-content {\n  --padding-bottom: 20px;\n}\n\nion-menu.ios ion-list {\n  padding: 20px 0 0 0;\n}\n\nion-menu.ios ion-note {\n  line-height: 24px;\n  margin-bottom: 20px;\n}\n\nion-menu.ios ion-item {\n  --padding-start: 16px;\n  --padding-end: 16px;\n  --min-height: 50px;\n}\n\nion-menu.ios ion-item.selected ion-icon {\n  color: var(--ion-color-default);\n}\n\nion-menu.ios ion-item ion-icon {\n  font-size: 24px;\n  color: #73849a;\n}\n\nion-menu.ios ion-list#labels-list ion-list-header {\n  margin-bottom: 8px;\n}\n\nion-menu.ios ion-list-header,\nion-menu.ios ion-note {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\nion-menu.ios ion-note {\n  margin-bottom: 8px;\n}\n\nion-menu {\n  --width: 100%;\n  --max-width: 100%;\n  --min-width: 100%;\n}\n\n.accounts_section {\n  border-right: 1px solid var(--ion-item-border-color);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ion-avatar {\n    width: 40px;\n    height: 40px;\n    background: var(--ion-color-danger);\n    border-radius: 34.5px;\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 0;\n    text-align: center;\n    color: var(--ion-color-primary-contrast);\n    border: 2px solid var(--ion-color-danger);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  ion-avatar.add_btn {\n    background: var(--ion-color-default);\n    border: 2px solid var(--ion-color-primary);\n  }\n\n  ion-avatar.active {\n    background: var(--ion-color-default);\n    border: 2px solid var(--ion-color-success);\n  }\n}\n\nion-note {\n  display: inline-block;\n  font-size: 16px;\n\n  color: var(--ion-color-medium-shade);\n}\n\nion-item.selected {\n  --color: var(--ion-color-default);\n}\n\nion-item.menu-profile-item {\n  padding-bottom: 25px;\n  margin-bottom: 0;\n  border-bottom: 1px solid var(--ion-item-border-color);\n  border-radius: 0 !important;\n\n  ion-avatar {\n    width: 56px;\n    height: 56px;\n    text-align: center;\n    font-size: 40px;\n    background: #FBFBFB;\n    line-height: 63px;\n\n    img {\n      width: 56px;\n      height: 56px;\n    }\n  }\n}\n\n.left-bottom-icons {\n  padding-bottom: 30px;\n}\n\n.network {\n  position: absolute;\n  top: 95%;\n  height: 5%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.online-bg-color {\n  background: #319718;\n}\n\n.offline-bg-color {\n  background: #cf0b0b;\n}\n\n// .main-router {\n//   margin-top: 46px;\n// }\n\n.orderApp {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 999;\n  box-shadow: none;\n  div {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    ion-icon {\n      margin-right: 6px;\n    }\n  }\n}\n\n// #inbox-list {\n//   height: calc(100% - 98px);\n//   overflow-x: hidden !important; // Force hide horizontal scrollbar\n//   overflow-y: auto; // Enable vertical scrolling\n  \n//   // Hide scrollbars completely by default\n//   &::-webkit-scrollbar {\n//     width: 0;\n//     height: 0;\n//     display: none;\n//   }\n  \n//   // Only on hover, show the vertical scrollbar\n//   &:hover {\n//     // For WebKit browsers (Chrome, Safari, Edge)\n//     &::-webkit-scrollbar {\n//       width: 6px;\n//       height: 0; // Keep horizontal scrollbar hidden\n//       display: block;\n//     }\n    \n//     &::-webkit-scrollbar-thumb {\n//       background-color: rgba(0, 0, 0, 0.2);\n//       border-radius: 3px;\n//     }\n    \n//     &::-webkit-scrollbar-track {\n//       background: transparent;\n//     }\n//   }\n  \n//   // Firefox scrollbar settings\n//   scrollbar-width: none; // Hide scrollbar by default\n  \n//   &:hover {\n//     scrollbar-width: thin; // Show thin scrollbar on hover\n//   }\n// }\n\n// // Additional rule to ensure horizontal scrolling is disabled\n// ion-menu-toggle, ion-item {\n//   max-width: 100%;\n//   overflow-x: hidden !important;\n// }\n\n\n// // First, let's fix the scrollbar issue\n// #inbox-list {\n//   height: calc(100% - 98px);\n//   overflow-x: hidden !important;\n//   overflow-y: auto;\n  \n//   // Hide scrollbars completely by default\n//   &::-webkit-scrollbar {\n//     width: 0;\n//     height: 0;\n//     display: none;\n//   }\n  \n//   // Only on hover, show the vertical scrollbar\n//   &:hover {\n//     &::-webkit-scrollbar {\n//       width: 6px;\n//       height: 0;\n//       display: block;\n//     }\n    \n//     &::-webkit-scrollbar-thumb {\n//       background-color: rgba(0, 0, 0, 0.2);\n//       border-radius: 3px;\n//     }\n    \n//     &::-webkit-scrollbar-track {\n//       background: transparent;\n//     }\n//   }\n  \n//   scrollbar-width: none;\n  \n//   &:hover {\n//     scrollbar-width: thin;\n//   }\n// }\n\n// // Now, let's add the desktop-only toggle for accounts_section\n// .accounts_section {\n//   // This will be visible by default on desktop\n//   display: flex;\n  \n//   // Add a toggle button that's only visible on desktop\n//   &-toggle {\n//     position: absolute;\n//     top: 10px;\n//     left: 10px;\n//     z-index: 100;\n//     background: rgba(255, 255, 255, 0.8);\n//     border-radius: 50%;\n//     width: 30px;\n//     height: 30px;\n//     display: none;\n//     justify-content: center;\n//     align-items: center;\n//     cursor: pointer;\n//     box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    \n//     ion-icon {\n//       font-size: 18px;\n//     }\n//   }\n  \n//   // Mobile styles - always hide both the section and toggle on mobile\n//   @media (max-width: 768px) {\n//     display: none;\n    \n//     &-toggle {\n//       display: none;\n//     }\n//   }\n  \n//   // Desktop styles - show the toggle\n//   @media (min-width: 769px) {\n//     &-toggle {\n//       display: flex;\n//     }\n    \n//     // When the section has the 'hidden' class, hide it\n//     &.hidden {\n//       display: none;\n//     }\n//   }\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
